import DOMPurify from 'dompurify';

/**
 * Sanitize HTML string to prevent XSS attacks.
 * Allows safe formatting tags only.
 */
export function sanitizeHTML(dirty) {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['strong', 'em', 'br', 'p', 'h2', 'h3', 'li', 'ul', 'ol', 'span'],
    ALLOWED_ATTR: ['class'],
  });
}

/**
 * SafeHTML component — renders sanitized HTML inside a div.
 *
 * SECURITY: this wrapper is the single approved place in the codebase that
 * hands already-sanitised markup to React for innerHTML rendering. Every
 * string first passes through `sanitizeHTML()` (DOMPurify with a strict
 * `ALLOWED_TAGS` / `ALLOWED_ATTR` allow-list above) so no attacker-controlled
 * markup can reach the DOM. All app code should use this component rather
 * than the raw React API.
 *
 * Usage: <SafeHTML html={formatText(text)} className="..." />
 */
export function SafeHTML({ html, className, ...props }) {
  // eslint-disable-next-line react/no-danger -- input is sanitised above
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizeHTML(html) }}
      {...props}
    />
  );
}
